import React, { useEffect } from "react";
import "./howtodonate.css";
import lefthand from "../../img/hand_donating.svg";

import righthand from "../../img/hand_donating_up.svg";
import sadapay from "../../img/sadapay.svg";
import Aos from "aos";
import "aos/dist/aos.css";
const Howtodonate = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div
      className="HowToDonate flex-container"
      id="donate-section"
      data-aos="fade-up"
    >
      <div className="donate-left-hand" data-aos="fade-left">
        <img src={lefthand} alt="donation"></img>
      </div>

      <div className="donate-section container">
        <span className="mmf-donate">How to Donate</span>
        <span>
          Make a Meaningful Donation to <br></br> Mehfooz Mustaqbil Foundation
        </span>
        <span>
          Mehfooz Mustaqbil foundation aims to provide underprivileged
          individuals with educational accessibility and equip them with the
          necessary tools and training for technical education
        </span>
        <div className="account-details">
          <div className="left-account-details">
            <img src={sadapay} alt="donation"></img>
          </div>

          <div className="right-account-details">
            <p>
              Account Title : <span className="acc-details">Rashid Hussain</span>
            </p>
            <p>
              Number : <span className="acc-details">0307 8611011</span>
            </p>
            <p>
              IBAN :{" "}
              <span className="acc-details">PK56SADA0000003078611011</span>
            </p>
          </div>
        </div>
        <span className="donate-last-txt">
          “Those who in charity spend of their goods by night and by day, in
          secret and in public, have their reward with their Lord: on them shall
          be no fear, nor shall they grieve” (2:274).
        </span>
      </div>

      <div className="donate-right-hand" data-aos="fade-right">
        <img src={righthand} alt="donation" fetchpriority="high"></img>
      </div>
    </div>
  );
};

export default Howtodonate;
